module.exports = __webpack_public_path__ + "static/media/080.5255d0e5.jpg";